import React, { createContext, useCallback, useState } from 'react';
import { PageZoomVal } from '../utils/context/PageZoom';
import { paperSizes } from '../utils/paperSizes';

export const PageSettingsContext = createContext();
const defaultPageSettings = {
  size: {
    widthInMM: 210,
    heightInMM: 297,
    widthInPX: 794,
    heightInPX: 1123,
  },

  type: 'A',
  name: 'A4',
  ppi: 96,
  margin: {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
  },
  scaling: 1,
  zoom: '100',
};

const PageSettingsProvider = ({ children, initialPageSetting = undefined }) => {
  const [pageSettings, setPageSettings] = useState(initialPageSetting || defaultPageSettings);
  const [isDragAndDropped, setIsDragAndDropped] = useState(false);

  const updatePageSettings = settings => {
    setPageSettings(settings);
  };

  const resetPageSettings = useCallback(() => {
    setPageSettings(defaultPageSettings);
  }, []);

  const updateTempPageSettings = template => {
    if (template?.pages?.length > 0) {
      const pageDPI = 96;
      const pageType = template.pages[0].size ? template.pages[0].size : 'a4';
      let newSettings = JSON.parse(JSON.stringify(pageSettings)); // Deep copying an Object
      newSettings.ppi = pageDPI;

      const zoomValue = localStorage.getItem('defaultZoom');
      const pageWrapper = document.getElementById('page-wrapper');
      const viewportDetails = pageWrapper.getBoundingClientRect();
      if (zoomValue) {
        let scaleZoomVal = PageZoomVal(zoomValue, pageSettings?.size, viewportDetails);
        newSettings.zoom = scaleZoomVal.zoom;
        newSettings.scaling = scaleZoomVal.scaling;
      }
      const paper = paperSizes.filter(paperDetails => {
        return paperDetails.lowercaseName === pageType;
      });
      if (paper && paper.length > 0) {
        const fetchedPaper = paper[0];
        newSettings.name = fetchedPaper.shortcut;
        newSettings.type = fetchedPaper.type;
        newSettings.size.widthInMM = fetchedPaper.size.widthInMM;
        newSettings.size.heightInMM = fetchedPaper.size.heightInMM;
        const resolutionSize = fetchedPaper.resolutions?.filter(resolution => {
          return resolution.ppi === pageDPI;
        });
        if (resolutionSize && resolutionSize.length > 0) {
          newSettings.size.widthInPX = resolutionSize[0].widthInPX;
          newSettings.size.heightInPX = resolutionSize[0].heightInPX;
        } else {
          newSettings.size.widthInPX = fetchedPaper.size.widthInPX;
          newSettings.size.heightInPX = fetchedPaper.size.heightInPX;
        }
      }
      updatePageSettings(newSettings);
    }
  };

  return (
    <PageSettingsContext.Provider
      value={{
        pageSettings,
        updatePageSettings,
        updateTempPageSettings,
        resetPageSettings,
        isDragAndDropped,
        setIsDragAndDropped
      }}
    >
      {children}
    </PageSettingsContext.Provider>
  );
};

export default PageSettingsProvider;
